
const AWS = require('aws-sdk');
const { SuccessResponse, ErrorResponse } = require("./response");
const { Region } = require("./env");

const RSA_PRIVATE_PREFIX = '-----BEGIN RSA PRIVATE KEY-----';
const RSA_PRIVATE_SUFFIX = '-----END RSA PRIVATE KEY-----';

const create_api = (creds) => {

  if (creds) {
    return new AWS.SecretsManager(creds.to_service());
  }

  return new AWS.SecretsManager({
    region: Region.region,
  });
}

const process_RSA_key = key => {

  if (!key.startsWith(RSA_PRIVATE_PREFIX
      || !key.endsWith(RSA_PRIVATE_SUFFIX))) {
    throw new Error("Key prefix/suffix error");
  }

  const key_len = key.length;
  const body = key.substring(
    RSA_PRIVATE_PREFIX.length, key_len - RSA_PRIVATE_SUFFIX.length)
    .trim()
    .split(" ");
  return RSA_PRIVATE_PREFIX + "\n" + body.join("\n") + "\n" + RSA_PRIVATE_SUFFIX;
};

const GetSecret = async (service, is_json=true) => {
  return await GetSecretC(null, service, is_json);
}

const GetSecretC = async (creds, service, is_json=true) => {
  const params = {
    SecretId: service,
  };

  const secrets_mgr = create_api(creds);

  try {
    const result = await secrets_mgr.getSecretValue(params).promise();
    if ('SecretString' in result) {
      if (is_json) {
        return SuccessResponse(JSON.parse(result.SecretString));
      }
      return SuccessResponse(result.SecretString)
    }

    return ErrorResponse("Response has no SecretString");
  } catch (err) {
    return ErrorResponse(err);
  }
};

const PutSecretValue = async (service, json) => {
  return await PutSecretValueC(null, service, json);
}

/**
 * @param creds {CaCredentails|null}
 * @param service {String} secret id
 * @param json {any} Secret to store.
 *
 * Since we usually are updating only part of the json,
 * you will have to load the json, update the part you
 * want, then write the entire blob at once.
 */
const PutSecretValueC = async (creds, service, json) => {
  const params = {
    SecretId: service,
    SecretString: JSON.stringify(json),
  }

  const secrets_mgr = create_api();

  try {
    return SuccessResponse(await secrets_mgr.putSecretValue(params).promise());
  } catch (err) {
    return ErrorResponse(err);
  }
}

module.exports = {
  GetSecret, GetSecretC, process_RSA_key, PutSecretValue, PutSecretValueC
};
